<template>
  <v-app v-if="isLoading">
    <loading />
  </v-app>
  <div v-else>
    <v-col cols="12" class="pa-3">
      <v-row>
        <v-col cols="12" lg="9">
            <v-card class="EK-card EK-shadow IMTOrange rounded-xl rounded-tr-0 text-center border-top border-right">
                <v-data-table dense
                              :headers="headers"
                              :items="this.notificationList"
                              hide-default-footer
                              :search="searchText"
                              :items-per-page="12"
                              :page.sync="page"
                              @page-count="pageCount = $event">
                    <template v-slot:item="{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <tr v-on="on"
                                    v-bind="attrs"
                                    >
                                    <td @click="goToDetails(item.id, item.shopId)">
                                        {{ !item.shopName ? "بلا مشترك" : item.shopName }}
                                    </td>
                                    <td @click="goToDetails(item.id, item.shopId)">{{ item.title }}</td>
                                    <td class="text-notification" @click="goToDetails(item.id, item.shopId)">
                                        <span>
                                            {{ item.body }}
                                        </span>
                                    </td>
                                    <td @click="goToDetails(item.id, item.shopId)">
                                        {{ item.isScheduled ? "مجدول" : "غير مجدول" }}
                                    </td>
                                    <td @click="goToDetails(item.id, item.shopId)">
                                        {{
                          new Date(item.createdAt).toLocaleTimeString("ar-GB") +
                          " " +
                          new Date(item.createdAt).toISOString().substr(0, 10)
                                        }}
                                    </td>
                                    <td @click="goToDetails(item.id, item.shopId)">
                                        {{
                          item.isScheduled
                            ? item.isSent
                              ? "مُرسَل"
                              : "غير مُرسَل"
                            : "مُرسَل"
                                        }}
                                    </td>
                                    <td>
                                        <v-btn @click="onConfirmDelete(item)" text>
                                            <img src="/media/svg/table/delete.svg" alt="delete" />
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                            <span>انقر لعرض التفاصيل</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
                <v-pagination color="IMThemeGray"
                              v-model="page"
                              :total-visible="16"
                              :length="pageCount"></v-pagination>
            </v-card>
        </v-col>
        <v-col cols="12" lg="3">
          <v-card class="mx-auto EK-card text-right rounded-xl rounded-tl-0 IMThemeGray">
            <v-card-text class="white rounded-b-xl">
              <v-img
                class="w-100"
                height="100"
                contain
                style="margin-top: -6px"
                src="/media/svg/victors/store-filter.svg"
              ></v-img>
            </v-card-text>
            <v-card-text class="pb-0">
              <label class="">بحث في الإشعارات</label>
              <v-text-field
                v-model="searchText"
                color="IMThemeGray"
                label="بحث في الجدول"
                dense
                solo
                rounded
                append-icon="mdi-magnify"
              ></v-text-field>
            </v-card-text>
            <v-card-text class="p-0">
              <template>
                <v-btn
                  @click="isShow()"
                  color="IMThemeOrange"
                  class="IMThemeGray w-100 rounded-0 text-white"
                >
                  إضافة إشعار
                  <v-icon left> mdi-plus </v-icon>
                </v-btn>
              </template>
            </v-card-text>
            <v-card-actions class="IMThemeGray"> </v-card-actions>
          </v-card>
        </v-col>
        <v-dialog v-model="show" width="1000px">
          <create-new :shopList="this.shopNotificationList" @close="isShow()" />
        </v-dialog>
      </v-row>
    </v-col>
  </div>
</template>
<style lang="scss">
.v-select__selections {
  padding-top: 4px;
}
.v-label {
  left: auto !important;
  right: 0 !important;
}
.v-input__slot {
  margin-bottom: 0 !important;
}
.v-chip--select {
  margin-bottom: 4px !important;
}
.v-chip__close {
  margin-right: 4px !important;
}
.v-application--is-rtl .v-btn__content .v-icon--left {
  margin-right: 5px;
}
.text-notification {
  span {
    margin: auto;
    overflow: hidden;
    white-space: nowrap;
    display: block;
    width: 180px;
    text-overflow: ellipsis;
  }
}
</style>
<script>
import loading from "@/components/loading";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import CreateNew from "./components/create-new.vue";
import aPagination from  'ant-design-vue/lib/pagination'
export default {
  name: "notification",
  components: {
    CreateNew,
    loading,
  },
  data: () => ({
    show: false,
    page: 1,
    pageCount: 0,
    searchText: "",
    filterArray: [],
    activedata: [],
    headers: [
      {
        text: "اسم المشترك",
        sortable: false,
        value: "name",
      },
      { text: "عنوان الإشعار", value: "title" },
      { text: "نص الإشعار", value: "description" },
      { text: "نوع الاشعار", value: "isScheduled" },
      { text: "تاريخ إرسال الإشعار", value: "date" },
      { text: "حالة الإشعار", value: "notiState" },
      // { text: "تاريخ", value: "notiState" },
      {
        text: "حذف",
        value: "delete",
        sortable: false,
      },
    ],
  }),
  computed: {
    ...mapGetters(["notificationList", "shopNotificationList", "isLoading"]),
  },
  created() {
    //this.activedata = this.notificationList.slice();
    this.$store.dispatch("setBreadcrumbs", [
      {
        text: "الإشعارات",
        disabled: false,
        href: "/notification",
      },
    ]);
    this.$store.dispatch("fetchNotification", 0);
  },
  watch: {
    filterArray(arr) {
      this.activedata = this.notificationList.filter((item, i) => {
        for (var key in item) {
          console.log(item[key]);
        }
      });
    },
  },
  methods: {
    onConfirmDelete(item) {
      Swal.fire({
        title: "هل انت متأكد من الحذف ؟",
        text: "مازال بإمكانك التراجع",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "تراجع",
        confirmButtonText: "أجل متأكد",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("deleteNotification", item);
        }
      });
    },
    isShow() {
      this.show = !this.show;
    },
    goToDetails(id, shopId) {
      if (shopId == null) {
        shopId = 0;
      }
      this.$router.push({
        path: `/notification/details/${shopId}/active-notification/${id}`,
        params: { shopId: shopId, notiyId: id },
      });
    },
  },
};
</script>
